module.exports = __webpack_public_path__ + "static/media/blood-orange-3.2ce57f98.png";